export enum MovementType {CREDIT = 'CREDIT', CHARGE = 'CHARGE'}

import * as moment from 'moment';

export class Movement {
  amount: number;
  date: Date;
  description: string;
  movementType: MovementType;
  reference: string;
  merchantCity: string;
  merchantName: string;
  merchantId: string;
  terminalId: string;
  mcc: string;
  isHoldTransaction: boolean;

  constructor(object: any = null) {
    if (object != null) {
      Object.assign(this, object);
      this.movementType = typeof object.movementType == 'number' ? object.movementType : MovementType[object.movementType as string];
      this.date = moment.utc(object.date, 'YYYY-MM-DD\'T\'HH:mm:ss').toDate();
    }
  }
}
